import styled, { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const WizardHeader = styled.div`
  .ant-progress {
    font-size: 0;
    line-height: 0;
    display: block;
    .ant-progress-inner {
      border-radius: 0;
    }
  }
`;

export const StepHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px;
  background-color: ${themeGet('text.0', '#2c2c2c')};
  .drawer-close-button {
    display: none;
    outline: none;
    padding: 0;
    background: transparent;
    border: 0;
    height: 24px;
    @media only screen and (max-width: 767px) {
      display: block;
    }
  }
  .drawer-back-button {
    outline: none;
    padding: 0;
    background: transparent;
    border: 0;
    height: 24px;
    @media only screen and (max-width: 767px) {
      display: block;
    }
  }
  .drawer-back-text {
    cursor: pointer;
  }
`;

export const StepHeadline = styled.h3`
  white-space: nowrap;
  height: 17px;
  margin: 1.5px 0 0 6.5px;
  text-align: center;
  color: ${themeGet('color.1', '#ffffff')};
  font-size: 15px;
  line-height: 17px;
`;

export const FormImage = styled.div`
  margin-left: 27px;
`;

export const FormWrapper = styled.div`
  padding: 20px 36px;
  @media only screen and (max-width: 991px) {
    padding: 20px 36px 72px;
  }
  &.reservation-flow {
    padding: 8px 36px 20px 36px;
    @media only screen and (max-width: 991px) {
      padding-bottom: 72px;
    }
  }
  &.guest-reservation-flow {
    padding: 27px 36px 20px 36px;
  }
  .ant-divider {
    .ant-divider-inner-text {
      font-size: 15px;
      color: ${themeGet('text.2', '#777777')};
    }
  }
  .ant-form-item {
    margin-bottom: 30px;
    .ant-form-item-label {
      font-weight: bold;
      padding-bottom: 0;
      margin-bottom: 4px;
    }
    &.ant-form-item-has-error {
      .ant-select {
        .ant-select-selector {
          border-color: ${themeGet('border.3', '#E6E6E6')} !important;
        }
      }
    }

    .ant-form-item-control {
      .ant-form-item-control-input {
        input.ant-input.input-field {
          width: 100%;
          border-radius: 2px;
          border: 1px solid ${themeGet('border.3', '#E6E6E6')};
          height: 47px;
          padding: 6px 20px;
          color: ${themeGet('text.0', '#2C2C2C')};
          font-size: 14px;
          &::placeholder {
            color: ${themeGet('text.3', '#8d8d8d')};
          }
          &:hover {
            border-color: ${themeGet('primary.0', '#194AB9')};
          }
        }
      }

      .ant-select {
        &.ant-select-focused {
          outline: 0;
          box-shadow: none !important;
        }
        .ant-select-selector {
          border-radius: 3px;
          border-color: ${themeGet('border.3', '#E6E6E6')};
          height: 47px;
          box-shadow: none !important;
          .ant-select-selection-item,
          .ant-select-selection-placeholder {
            line-height: 47px;
          }
          &:active,
          &:hover {
            border-color: ${themeGet('primary.0', '#008489')} !important;
          }
          .ant-select-selection-search {
            .ant-select-selection-search-input {
              height: 45px;
            }
          }
        }
        .ant-select-selection-item,
        .ant-select-selection-placeholder,
        .ant-select-selection-search-input {
          padding-left: 8px;
          font-size: 14px;
        }
        .ant-select-selection-placeholder {
          color: ${themeGet('text.3', '#8d8d8d')};
        }
        .ant-select-selection-item,
        .ant-select-selection-search-input {
          color: ${themeGet('text.0', '#2C2C2C')};
        }
        &.add-new {
          .ant-select-selection-placeholder {
            color: ${themeGet('text.0', '#2C2C2C')};
          }
        }
      }
    }
    .ant-form-item-explain {
      position: absolute;
      top: 100%;
    }
  }
  .signin-btn,
  .signup-btn,
  .request-btn,
  .connect-btn,
  .continue-btn {
    height: 47px;
    width: 100%;
    border-radius: 2px;
    font-weight: bold;
  }
  .please-login-btn {
    padding: 0;
    height: auto;
  }
  &.connect-form,
  &.request-form {
    form {
      margin-bottom: 30px;
    }
  }
  .ant-alert {
    margin-bottom: 30px;
  }
  form.error {
    .ant-form-item {
      margin-bottom: 10px;
    }
    .ant-alert {
      margin-bottom: 19px;
    }
  }
`;

export const Title = styled.h2`
  font-size: 25px;
  line-height: 34px;
  font-weight: bold;
  margin-bottom: 8px;
  color: ${themeGet('text.0', '#2C2C2C')};
`;

export const SubTitle = styled.p`
  font-size: 15px;
  line-height: 1.47;
  color: ${themeGet('text.3', '#8d8d8d')};
  margin-bottom: 30px;
  b {
    color: ${themeGet('text.4', '#323232')};
  }
`;

export const TitleInfo = styled.p`
  font-size: 15px;
  line-height: 18px;
  margin-bottom: 30px;
`;

export const BottomInfo = styled.p`
  text-align: center;
  font-size: 15px;
  line-height: 18px;
  color: ${themeGet('text.2', '#777777')};
  a {
    color: ${themeGet('primary.0', '#194AB9')};
    font-weight: bold;
    &:hover,
    &:focus {
      outline: none;
      color: ${themeGet('primary.0', '#194AB9')};
      text-decoration: none;
    }
  }
  &.connect-bottom-info,
  &.request-bottom-info {
    font-size: 14px;
    line-height: 1.64;
  }
  .bottom-link {
    white-space: nowrap;
  }
`;

export const FieldWrapper = styled.div`
  .ant-form-item-control {
    line-height: 18px;
  }
  &.forgot-password {
    text-align: right;
    margin-bottom: 30px;
    a {
      font-size: 12px;
      line-height: 15px;
      color: ${themeGet('text.0', '#323232')};
      &:hover {
        color: ${themeGet('primary.0', '#194AB9')};
      }
    }
  }
`;

export const SwitchWrapper = styled.div`
  .terms-field {
    line-height: 18px;
  }
`;

export const Label = styled.span`
  font-size: 12px;
  a {
    margin-left: 3px;
  }
`;

export const ConnectedCardIconWrapper = styled.div`
  position: relative;
  width: 136px;
  height: 90px;
  .anticon {
    position: absolute;
    top: -16px;
    left: -16px;
  }
`;

export const GuestLinkWrapper = styled.div`
  text-align: right;
  margin-bottom: 8px;
  a {
    color: ${themeGet('text.3', '#8d8d8d')};
    text-decoration: underline;
    &:hover {
      text-decoration: none;
    }
  }
`;

export const SelectActions = styled.div`
  .add_vessel {
    font-size: 15px;
    font-weight: bold;
    color: ${themeGet('primary.0', '#194AB9')};
  }
`;
